(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CasNonReleveDialogController', CasNonReleveDialogController);

    CasNonReleveDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CasNonReleve'];

    function CasNonReleveDialogController ($scope, $stateParams, $uibModalInstance, entity, CasNonReleve) {
        var vm = this;
        vm.casNonReleve = entity;
        vm.load = function(id) {
            CasNonReleve.get({id : id}, function(result) {
                vm.casNonReleve = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:casNonReleveUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.casNonReleve.id !== null) {
                CasNonReleve.update(vm.casNonReleve, onSaveSuccess, onSaveError);
            } else {
                CasNonReleve.save(vm.casNonReleve, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
